import React from 'react';
import '../../styles/PartnerWithUs.css';

const numberItems = [
  { number: '1', text: 'Career Breakthroughs' },
  { number: '2', text: 'Financial Success' },
];

function PartnerNumberGrid() {
  return (
    <section className="partnerNumberGrid">
      <div className="numberGridContainer twoColumnLayout">
        {numberItems.map((item, index) => (
          <div key={index} className="numberGridItem">
            <div className="numberIcon">{item.number}</div>
            <div className="numberLabel">{item.text}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PartnerNumberGrid;
